/**
 * sgpFlowStyles.js — static StyleSheet extracted from SgpFlowScreen.jsx
 * (god-file decomposition). Purely presentational constants; no logic.
 */

import { StyleSheet, Platform } from 'react-native';
import { responsive, isMobile } from '../utils/responsive';
import { uiVar } from '../components/floodlight/uiStyleCss';

export const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: uiVar('rs-fill-page', '#000000'),
        minHeight: Platform.OS === 'web' ? '110vh' : '100%',
    },
    background: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: uiVar('rs-fill-page', '#000000'),
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 4 },
        shadowOpacity: 0.25,
        shadowRadius: 4,
    },
    splashContainer: {
        flex: 1,
        width: '100%',
        height: '100%',
        paddingHorizontal: responsive(12, 24, Platform.OS === 'web' ? 48 : 24),
        paddingTop: responsive(12, 20, Platform.OS === 'web' ? 32 : 16),
        paddingBottom: responsive(16, 32, Platform.OS === 'web' ? 48 : 24),
        gap: responsive(16, 32, 48),
    },
    mainContent: {
        alignItems: 'center',
        width: '100%',
        gap: responsive(12, 18, 24),
        flex: 1,
        borderRadius: responsive(12, 16, 20),
        backgroundColor: uiVar('rs-fill-page', '#000'),
        borderWidth: 1,
        borderBottomWidth: 2,
        borderTopColor: uiVar('rs-line-hair2', 'rgba(255,255,255,0.25)'),
        borderLeftColor: uiVar('rs-line-hair2', 'rgba(255,255,255,0.18)'),
        borderRightColor: uiVar('rs-line-hair2', 'rgba(255,255,255,0.12)'),
        borderBottomColor: uiVar('rs-line-hair', 'rgba(255,255,255,0.08)'),
    },
    blurContent: {
        alignItems: 'center',
        width: '100%',
        gap: responsive(12, 18, 24),
        flex: 1,
        borderRadius: responsive(12, 16, 20),
        paddingHorizontal: responsive(12, 24, 48),
        paddingVertical: responsive(12, 16, 20),
    },
    modeChip: {
        paddingVertical: 6,
        paddingHorizontal: 10,
        borderRadius: 14,
        borderWidth: 1,
        borderColor: uiVar('rs-line-hair2', 'rgba(255,255,255,0.18)')
    },
    modeChipActive: {
        backgroundColor: uiVar('rs-fill-solid', 'rgba(255,255,255,0.18)'),
        borderColor: uiVar('rs-line-ink', 'rgba(255,255,255,0.28)')
    },
    modeChipText: { color: uiVar('rs-text-ink', 'rgba(255,255,255,0.85)'), fontWeight: '600' },
    modeChipTextActive: { color: uiVar('rs-text-on-active', '#000') },
    backButtonContainer: {
        alignSelf: 'flex-start',
        marginBottom: 8,
    },
    backButton: {
        paddingLeft: 16,
        paddingRight: 16,
        paddingTop: 8,
        paddingBottom: 8,
        backgroundColor: 'rgba(0, 0, 0, 0)',
        borderRadius: 4,
        borderWidth: 1,
        borderColor: uiVar('rs-line-hair2', 'rgba(255, 255, 255, 0.20)'),
        justifyContent: 'center',
        alignItems: 'center',
    },
    // Bet Slip Section Styles
    betSlipSection: {
        width: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0)',
        borderRadius: 20,
        gap: 32,
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    },
    noResultsContainer: {
        flex: 1,
        width: '100%',
        alignItems: 'center',
        justifyContent: 'center',
        paddingVertical: 48,
        paddingHorizontal: 24,
        gap: 0,
    },
    noResultsIconWrap: {
        width: 72,
        height: 72,
        borderRadius: 36,
        backgroundColor: uiVar('rs-fill-wash2', 'rgba(255,255,255,0.05)'),
        borderWidth: 1,
        borderColor: uiVar('rs-line-hair', 'rgba(255,255,255,0.08)'),
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: 20,
    },
    noResultsTitle: {
        fontSize: 18,
        fontWeight: '700',
        color: uiVar('rs-text-ink', 'rgba(255,255,255,0.85)'),
        textAlign: 'center',
        marginBottom: 10,
        fontFamily: Platform.OS === 'web' ? uiVar('rs-font-body', "Slate, -apple-system, system-ui") : 'System',
    },
    noResultsSubtitle: {
        fontSize: 13,
        color: uiVar('rs-text-muted', 'rgba(255,255,255,0.45)'),
        textAlign: 'center',
        lineHeight: 20,
        maxWidth: 320,
        marginBottom: 28,
        fontFamily: Platform.OS === 'web' ? uiVar('rs-font-body', "Slate, -apple-system, system-ui") : 'System',
    },
    noResultsActions: {
        flexDirection: 'row',
        gap: 10,
        flexWrap: 'wrap',
        justifyContent: 'center',
    },
    noResultsBtn: {
        flexDirection: 'row',
        alignItems: 'center',
        paddingVertical: 10,
        paddingHorizontal: 18,
        borderRadius: 10,
        ...(Platform.OS === 'web' && { cursor: 'pointer' }),
    },
    noResultsBtnPrimary: {
        backgroundColor: uiVar('rs-fill-wash3', 'rgba(255,255,255,0.12)'),
        borderWidth: 1,
        borderColor: uiVar('rs-line-hair2', 'rgba(255,255,255,0.18)'),
    },
    noResultsBtnSecondary: {
        backgroundColor: uiVar('rs-fill-wash2', 'rgba(255,255,255,0.05)'),
        borderWidth: 1,
        borderColor: uiVar('rs-line-hair', 'rgba(255,255,255,0.1)'),
    },
    noResultsBtnText: {
        fontSize: 13,
        fontWeight: '600',
        color: uiVar('rs-text-ink', 'rgba(255,255,255,0.9)'),
        fontFamily: Platform.OS === 'web' ? uiVar('rs-font-body', "Slate, -apple-system, system-ui") : 'System',
    },
    betSlipHeader: {
        alignSelf: 'stretch',
        flex: 1,
        paddingTop: 24,
        backgroundColor: 'rgba(255, 255, 255, 0)',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 32,
    },
    betSlipTitleContainer: {
        alignSelf: 'stretch',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 32,
        flexDirection: 'row',
    },
    betSlipTitle: {
        flex: 1,
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        gap: 5,
    },
    betSlipTitleText: {
        alignSelf: 'stretch',
        color: uiVar('rs-text-ink2', 'rgba(255, 255, 255, 0.80)'),
        fontSize: 20,
        fontFamily: uiVar('rs-font-body', 'Slate'),
        fontWeight: '500',
        lineHeight: 24,
    },
    betSlipSubtitle: {
        alignSelf: 'stretch',
        color: uiVar('rs-text-ink2', 'rgba(255, 255, 255, 0.80)'),
        fontSize: 16,
        fontFamily: uiVar('rs-font-body', 'Slate'),
        fontWeight: '500',
        lineHeight: 24,
    },
    viewBetslipButton: {
        paddingLeft: 16,
        paddingRight: 16,
        paddingTop: 8,
        paddingBottom: 8,
        backgroundColor: 'rgba(0, 0, 0, 0)',
        borderRadius: 4,
        borderWidth: 1,
        borderColor: uiVar('rs-line-hair2', 'rgba(255, 255, 255, 0.20)'),
        justifyContent: 'center',
        alignItems: 'center',
    },
    betCardsContainer: {
        alignSelf: 'stretch',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        gap: 16
    },
    selectedButton: {
        backgroundColor: 'rgba(0, 0, 0, 0)',
        boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
        borderRadius: 4,
        borderWidth: 2,
        borderColor: 'rgba(255, 255, 255, 0)',
    },
    betSlipFooter: {
        alignSelf: 'stretch',
        height: 36,
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        flexDirection: 'row',
    },
    legNumbers: {
        flex: 1,
        maxWidth: 900,
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        flexDirection: 'row',
    },
    legNumber: {
        position: 'relative',
        padding: 8,
        borderRadius: 4,
        justifyContent: 'center',
        alignItems: 'center',
        borderWidth: 1,
        borderColor: 'transparent',
        overflow: 'hidden',
    },
    activeLegNumber: {
        // background gradient handled via overlays
        boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25) inset',
        borderTopColor: uiVar('rs-line-hair2', 'rgba(255, 255, 255, 0.20)'),
        borderLeftColor: uiVar('rs-line-hair', 'rgba(255, 255, 255, 0.09)'),
        borderRightColor: uiVar('rs-line-hair2', 'rgba(255, 255, 255, 0.12)'),
        borderBottomColor: uiVar('rs-line-hair', 'rgba(255, 255, 255, 0.06)'),
    },
    legNumberText: {
        width: 20,
        textAlign: 'center',
        color: uiVar('rs-text-muted', '#707070'),
        fontSize: 15,
        fontFamily: uiVar('rs-font-body', 'ShantellSans'),
        fontWeight: '500',
        lineHeight: 20,
        zIndex: 1,
    },
    addLegButton: {
        padding: 8,
        backgroundColor: 'rgba(255, 255, 255, 0)',
        borderRadius: 4,
        justifyContent: 'center',
        alignItems: 'center',
    },
    addLegIcon: {
        width: 20,
        height: 20,
        textAlign: 'center',
        color: uiVar('rs-text-muted', 'rgba(255, 255, 255, 0.40)'),
        fontSize: 15,
        fontFamily: uiVar('rs-font-body', 'Shantell Sans'),
        fontWeight: '500',
        lineHeight: 20,
    },
    footerActions: {
        width: 319,
        justifyContent: 'flex-end',
        alignItems: 'center',
        gap: 20,
        flexDirection: 'row',
    },
    footerButton: {
        // GradientButton handles its own styling
    },
    paginationContainer: {
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        paddingVertical: 12,
        paddingHorizontal: 16,
        marginTop: 16,
        marginBottom: 8,
        backgroundColor: uiVar('rs-fill-sunken', 'rgba(0, 0, 0, 0.3)'),
        borderRadius: 8,
        alignSelf: 'stretch',
        borderWidth: 1,
        borderColor: uiVar('rs-line-hair', 'rgba(255, 255, 255, 0.1)'),
    },
    paginationRow: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
    },
    paginationButton: {
        paddingVertical: 8,
        paddingHorizontal: 16,
        backgroundColor: uiVar('rs-fill-wash2', 'rgba(255, 255, 255, 0.08)'),
        borderRadius: 6,
        borderWidth: 1,
        borderColor: uiVar('rs-line-hair2', 'rgba(255, 255, 255, 0.2)'),
    },
    paginationButtonDisabled: {
        backgroundColor: uiVar('rs-fill-wash1', 'rgba(255, 255, 255, 0.02)'),
        borderColor: uiVar('rs-line-hair', 'rgba(255, 255, 255, 0.05)'),
    },
    paginationButtonText: {
        color: uiVar('rs-text-ink', 'rgba(255, 255, 255, 0.9)'),
        fontSize: 14,
        fontFamily: uiVar('rs-font-body', 'Slate'),
        fontWeight: '500',
    },
    paginationButtonTextDisabled: {
        color: uiVar('rs-text-faint', 'rgba(255, 255, 255, 0.3)'),
    },
    paginationText: {
        color: uiVar('rs-text-ink2', 'rgba(255, 255, 255, 0.8)'),
        fontSize: 14,
        fontFamily: uiVar('rs-font-body', 'Slate'),
        fontWeight: '500',
    },
    paginationPagesRow: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        flexWrap: 'wrap',
        gap: 6,
    },
    paginationPageButton: {
        minWidth: 32,
        paddingVertical: 6,
        paddingHorizontal: 10,
        backgroundColor: uiVar('rs-fill-wash2', 'rgba(255, 255, 255, 0.08)'),
        borderRadius: 6,
        borderWidth: 1,
        borderColor: uiVar('rs-line-hair2', 'rgba(255, 255, 255, 0.2)'),
        alignItems: 'center',
        justifyContent: 'center',
    },
    paginationPageButtonActive: {
        backgroundColor: uiVar('rs-fill-solid', 'rgba(139, 92, 246, 0.4)'),
        borderColor: uiVar('rs-line-ink', 'rgba(167, 139, 250, 0.6)'),
    },
    paginationPageButtonText: {
        color: uiVar('rs-text-ink', 'rgba(255, 255, 255, 0.9)'),
        fontSize: 14,
        fontFamily: uiVar('rs-font-body', 'Slate'),
        fontWeight: '500',
    },
    paginationPageButtonTextActive: {
        color: uiVar('rs-text-on-active', '#fff'),
        fontWeight: '600',
    },
    paginationEllipsis: {
        color: uiVar('rs-text-muted', 'rgba(255, 255, 255, 0.5)'),
        fontSize: 14,
        paddingHorizontal: 2,
    },
    // ⭐ TOP CONTROLS: Pagination + Show All Math
    topControlsContainer: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingVertical: 10,
        paddingHorizontal: 12,
        marginBottom: 12,
        backgroundColor: uiVar('rs-fill-sunken', 'rgba(0, 0, 0, 0.4)'),
        borderRadius: 10,
        borderWidth: 1,
        borderColor: uiVar('rs-line-hair', 'rgba(255, 255, 255, 0.1)'),
        gap: 12,
    },
    showAllMathButton: {
        paddingVertical: 8,
        paddingHorizontal: 14,
        backgroundColor: uiVar('rs-fill-wash2', 'rgba(255, 255, 255, 0.08)'),
        borderRadius: 8,
        borderWidth: 1,
        borderColor: uiVar('rs-line-hair2', 'rgba(255, 255, 255, 0.2)'),
    },
    showAllMathButtonActive: {
        backgroundColor: uiVar('rs-fill-pos-wash', 'rgba(74, 222, 128, 0.2)'),
        borderColor: uiVar('rs-line-pos', 'rgba(74, 222, 128, 0.5)'),
    },
    showAllMathButtonText: {
        color: uiVar('rs-text-ink', 'rgba(255, 255, 255, 0.9)'),
        fontSize: 13,
        fontWeight: '600',
    },
    showAllMathButtonTextActive: {
        color: uiVar('rs-text-pos', '#4ADE80'),
    },
    topPaginationContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 8,
        flex: 1,
        justifyContent: 'space-between',
    },
    topPaginationButton: {
        paddingVertical: 6,
        paddingHorizontal: 12,
        backgroundColor: uiVar('rs-fill-wash2', 'rgba(255, 255, 255, 0.08)'),
        borderRadius: 6,
        borderWidth: 1,
        borderColor: uiVar('rs-line-hair2', 'rgba(255, 255, 255, 0.2)'),
    },
    topPaginationButtonDisabled: {
        backgroundColor: uiVar('rs-fill-wash1', 'rgba(255, 255, 255, 0.02)'),
        borderColor: uiVar('rs-line-hair', 'rgba(255, 255, 255, 0.05)'),
    },
    topPaginationButtonText: {
        color: uiVar('rs-text-ink', 'rgba(255, 255, 255, 0.9)'),
        fontSize: 13,
        fontWeight: '500',
    },
    topPaginationButtonTextDisabled: {
        color: uiVar('rs-text-faint', 'rgba(255, 255, 255, 0.3)'),
    },
    topPaginationText: {
        color: uiVar('rs-text-ink2', 'rgba(255, 255, 255, 0.7)'),
        fontSize: 13,
        fontWeight: '500',
        minWidth: 50,
        textAlign: 'center',
    },
    rocketImage: {
        width: 400,
        height: 400,
        position: 'absolute',
        right: -50,
        top: -50,
        transform: [{ rotate: '-16deg' }],
    },
    feedbackButton: {
        padding: 8,
        borderRadius: 6,
        backgroundColor: uiVar('rs-fill-wash2', 'rgba(255, 255, 255, 0.05)'),
        borderWidth: 1,
        borderColor: uiVar('rs-line-hair', 'rgba(255, 255, 255, 0.1)'),
        minWidth: 36,
        alignItems: 'center',
        justifyContent: 'center',
    },
    feedbackButtonActive: {
        backgroundColor: uiVar('rs-fill-pos-wash', 'rgba(74, 222, 128, 0.15)'),
        borderColor: uiVar('rs-line-pos', '#4ade80'),
    },
    // Filter Panel Styles
    filterPanel: {
        alignSelf: 'stretch',
        backgroundColor: uiVar('rs-fill-wash1', 'rgba(255,255,255,0.03)'),
        borderRadius: 12,
        borderWidth: 1,
        borderColor: uiVar('rs-line-hair', 'rgba(255,255,255,0.08)'),
        padding: 16,
        marginBottom: 16,
        gap: 16,
    },
    filterHeader: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        paddingBottom: 12,
        borderBottomWidth: 1,
        borderBottomColor: uiVar('rs-line-hair', 'rgba(255,255,255,0.08)'),
    },
    filterTitle: {
        color: uiVar('rs-text-ink', '#fff'),
        fontSize: 18,
        fontWeight: '700',
    },
    filterSubtitle: {
        color: uiVar('rs-text-ink2', 'rgba(255,255,255,0.6)'),
        fontSize: 12,
    },
    searchedBookTag: {
        color: uiVar('rs-text-pos', '#4ade80'),
        fontSize: 11,
        fontWeight: '600',
        backgroundColor: uiVar('rs-fill-pos-wash', 'rgba(74, 222, 128, 0.12)'),
        paddingHorizontal: 6,
        paddingVertical: 2,
        borderRadius: 4,
    },
    searchContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        backgroundColor: uiVar('rs-fill-wash2', 'rgba(255,255,255,0.05)'),
        borderRadius: 8,
        borderWidth: 1,
        borderColor: uiVar('rs-line-hair2', 'rgba(255,255,255,0.12)'),
        paddingHorizontal: 12,
        paddingVertical: 10,
    },
    searchInput: {
        flex: 1,
        color: uiVar('rs-text-ink', '#fff'),
        fontSize: 14,
        fontWeight: '500',
    },
    filtersRow: {
        gap: 16,
    },
    filterSection: {
        gap: 8,
    },
    filterSectionHeader: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    filterLabel: {
        color: uiVar('rs-text-ink', 'rgba(255,255,255,0.9)'),
        fontSize: 13,
        fontWeight: '700',
        textTransform: 'uppercase',
        letterSpacing: 0.5,
    },
    clearButton: {
        color: uiVar('rs-text-neg', '#f87171'),
        fontSize: 11,
        fontWeight: '600',
    },
    filterTagsContainer: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: 6,
    },
    filterTag: {
        flexDirection: 'row',
        alignItems: 'center',
        paddingVertical: 7,
        paddingHorizontal: 12,
        borderRadius: 6,
        backgroundColor: uiVar('rs-fill-wash2', 'rgba(255, 255, 255, 0.06)'),
        borderWidth: 1,
        borderColor: uiVar('rs-line-hair2', 'rgba(255, 255, 255, 0.15)'),
    },
    filterTagActive: {
        backgroundColor: uiVar('rs-fill-pos-wash', 'rgba(74, 222, 128, 0.2)'),
        borderColor: uiVar('rs-line-pos', '#4ade80'),
    },
    filterTagText: {
        color: uiVar('rs-text-ink', 'rgba(255, 255, 255, 0.85)'),
        fontSize: 12,
        fontWeight: '600',
    },
    filterTagTextActive: {
        color: uiVar('rs-text-pos', '#4ade80'),
    },
    noFiltersText: {
        color: uiVar('rs-text-muted', 'rgba(255,255,255,0.4)'),
        fontSize: 12,
        fontStyle: 'italic',
    },
    clearAllButton: {
        alignSelf: 'center',
        paddingVertical: 8,
        paddingHorizontal: 16,
        backgroundColor: uiVar('rs-fill-neg-wash', 'rgba(248, 113, 113, 0.1)'),
        borderRadius: 6,
        borderWidth: 1,
        borderColor: uiVar('rs-line-neg', 'rgba(248, 113, 113, 0.3)'),
    },
    clearAllButtonText: {
        color: uiVar('rs-text-neg', '#f87171'),
        fontSize: 13,
        fontWeight: '700',
    },
    // ── Hover styles ─────────────────────────────────────────────────────────
    paginationButtonHovered: {
        backgroundColor: uiVar('rs-fill-wash4', 'rgba(255,255,255,0.14)'),
        borderColor: uiVar('rs-line-ink', 'rgba(255,255,255,0.3)'),
    },
    paginationPageButtonHovered: {
        backgroundColor: uiVar('rs-fill-wash3', 'rgba(255,255,255,0.1)'),
        borderColor: uiVar('rs-line-hair2', 'rgba(255,255,255,0.25)'),
    },
    showAllMathButtonHovered: {
        backgroundColor: uiVar('rs-fill-wash4', 'rgba(255,255,255,0.14)'),
        borderColor: uiVar('rs-line-ink', 'rgba(255,255,255,0.3)'),
    },
    feedbackButtonHovered: {
        backgroundColor: uiVar('rs-fill-wash3', 'rgba(255,255,255,0.1)'),
        borderColor: uiVar('rs-line-hair2', 'rgba(255,255,255,0.25)'),
    },
    bookOverrideBtnHovered: {
        backgroundColor: uiVar('rs-fill-wash4', 'rgba(255,255,255,0.14)'),
        borderColor: uiVar('rs-line-ink', 'rgba(255,255,255,0.35)'),
    },
    clearOverrideBtnHovered: {
        backgroundColor: uiVar('rs-fill-neg-wash', 'rgba(248,113,113,0.2)'),
        borderColor: uiVar('rs-line-neg', 'rgba(248,113,113,0.55)'),
    },
    savedRequestsBtnHovered: {
        backgroundColor: uiVar('rs-fill-select', 'rgba(139,92,246,0.28)'),
        borderColor: uiVar('rs-line-ink', '#a78bfa'),
    },
    bookOptionHovered: {
        backgroundColor: uiVar('rs-fill-wash2', 'rgba(255,255,255,0.07)'),
    },
    clearAllButtonHovered: {
        backgroundColor: uiVar('rs-fill-neg-wash', 'rgba(248,113,113,0.18)'),
        borderColor: uiVar('rs-line-neg', 'rgba(248,113,113,0.5)'),
    },
    // ─────────────────────────────────────────────────────────────────────────
    // Book Override Styles
    bookOverrideBtn: {
        paddingVertical: 6,
        paddingHorizontal: 12,
        backgroundColor: uiVar('rs-fill-wash2', 'rgba(255, 255, 255, 0.08)'),
        borderRadius: 6,
        borderWidth: 1,
        borderColor: uiVar('rs-line-hair2', 'rgba(255, 255, 255, 0.2)'),
    },
    bookOverrideBtnActive: {
        backgroundColor: uiVar('rs-fill-pos-wash', 'rgba(74, 222, 128, 0.15)'),
        borderColor: uiVar('rs-line-pos', '#4ade80'),
    },
    bookOverrideBtnText: {
        color: uiVar('rs-text-ink2', 'rgba(255, 255, 255, 0.8)'),
        fontSize: 13,
        fontWeight: '500',
    },
    bookOverrideBtnTextActive: {
        color: uiVar('rs-text-pos', '#4ade80'),
        fontWeight: '600',
    },
    clearOverrideBtn: {
        paddingVertical: 4,
        paddingHorizontal: 8,
        backgroundColor: uiVar('rs-fill-neg-wash', 'rgba(248, 113, 113, 0.1)'),
        borderRadius: 4,
        borderWidth: 1,
        borderColor: uiVar('rs-line-neg', 'rgba(248, 113, 113, 0.3)'),
    },
    clearOverrideBtnText: {
        color: uiVar('rs-text-neg', '#f87171'),
        fontSize: 16,
        fontWeight: '700',
    },
    bookSelectorDropdown: {
        position: 'absolute',
        top: 60,
        left: 0,
        right: 0,
        backgroundColor: uiVar('rs-fill-raised', 'rgba(0, 0, 0, 0.95)'),
        borderRadius: 8,
        borderWidth: 1,
        borderColor: uiVar('rs-line-hair2', 'rgba(255, 255, 255, 0.2)'),
        padding: 12,
        zIndex: 1000,
        maxHeight: 300,
    },
    bookSelectorTitle: {
        color: uiVar('rs-text-ink', 'rgba(255, 255, 255, 0.9)'),
        fontSize: 14,
        fontWeight: '600',
        marginBottom: 8,
    },
    bookList: {
        maxHeight: 200,
    },
    bookOption: {
        paddingVertical: 8,
        paddingHorizontal: 12,
        borderRadius: 6,
        marginBottom: 4,
    },
    bookOptionActive: {
        backgroundColor: uiVar('rs-fill-pos-wash', 'rgba(74, 222, 128, 0.15)'),
        borderWidth: 1,
        borderColor: uiVar('rs-line-pos', '#4ade80'),
    },
    bookOptionText: {
        color: uiVar('rs-text-ink2', 'rgba(255, 255, 255, 0.8)'),
        fontSize: 13,
    },
    bookOptionTextActive: {
        color: uiVar('rs-text-pos', '#4ade80'),
        fontWeight: '600',
    },
    savedRequestsBtn: {
        paddingVertical: 6,
        paddingHorizontal: 12,
        backgroundColor: uiVar('rs-fill-select', 'rgba(139, 92, 246, 0.15)'),
        borderRadius: 6,
        borderWidth: 1,
        borderColor: uiVar('rs-line-ink', '#8b5cf6'),
    },
    savedRequestsBtnText: {
        color: uiVar('rs-text-accent', '#8b5cf6'),
        fontSize: 13,
        fontWeight: '600',
    },
    // Share Modal Styles
    searchBarContainer: {
        width: '100%',
        paddingHorizontal: isMobile ? 8 : (Platform.OS === 'web' ? 16 : 12),
        marginBottom: isMobile ? 12 : 16,
    },
    searchInputWrapper: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: isMobile ? 8 : 12,
        backgroundColor: uiVar('rs-fill-sunken', 'rgba(0, 0, 0, 0.4)'),
        borderRadius: isMobile ? 10 : 12,
        borderWidth: 1,
        borderColor: uiVar('rs-line-hair2', 'rgba(255, 255, 255, 0.15)'),
        paddingHorizontal: isMobile ? 12 : 16,
        paddingVertical: isMobile ? 10 : 12,
    },
    searchInput: {
        flex: 1,
        fontFamily: uiVar('rs-font-body', 'Slate'),
        fontSize: Platform.OS === 'web' ? 16 : 15,
        fontWeight: '500',
        color: uiVar('rs-text-ink', 'rgba(255, 255, 255, 0.9)'),
        ...(Platform.OS === 'web' ? { outlineStyle: 'none' } : {}),
    },
    searchButton: {
        paddingVertical: 8,
        paddingHorizontal: 16,
        backgroundColor: uiVar('rs-fill-wash3', 'rgba(255, 255, 255, 0.1)'),
        borderRadius: 8,
        borderWidth: 1,
        borderColor: uiVar('rs-line-hair2', 'rgba(255, 255, 255, 0.2)'),
    },
    searchButtonText: {
        fontFamily: uiVar('rs-font-body', 'Slate'),
        fontSize: 14,
        fontWeight: '700',
        color: uiVar('rs-text-ink', 'rgba(255, 255, 255, 0.9)'),
    },
    searchButtonTextDisabled: {
        color: uiVar('rs-text-faint', 'rgba(255, 255, 255, 0.3)'),
    },
});
